<div class="icon-container">
  @if (!adminMode) {
    <button mat-icon-button (click)="downloadSelectedDocuments()">
      <mat-icon matTooltip="View document"> download </mat-icon>
    </button>
  }
  <button *ngIf="!locked" mat-icon-button (click)="onClick()">
    <mat-icon [matTooltip]="adminMode ? 'edit' : 'view all data'" class="material-symbols-outlined">
      {{ adminMode ? 'edit' : 'expand_content' }}
    </mat-icon>
  </button>
</div>
